Run:

  cofactor external-run debug overview <run-id>

The overview shows the customer-safe orchestration timeline: run state, parent
and shard job phases, attempts, timeouts, reschedules, launch completion, and
whether a later attempt recovered. It deliberately excludes job payloads,
arbitrary metadata, launch commands, environment variables, substrate handles,
and cloud resource identifiers.

`recovered_after_retry` means at least one shard attempt timed out and a later
attempt for that shard completed before the run sealed. That is a real harness
event, but not automatically the explanation for every failed assertion in the
run. Correlate timestamps and scenario attempts.

`collecting` is not by itself stuck. Check current phases/runAt timestamps and
poll again. A sealed run with recovered retries completed; report the transient
timeout and recovery rather than calling it permanently stuck.
